import { combineEpics } from "redux-observable";
import { jetliftCalculationEpic } from "./jetliftcalculation.epic";
import { jetLiftTubingEpic } from "./jetlift-input/tubing.epic";
import { jetLiftWellEpic } from "./jetlift-input/well.epic";
import { jetLiftFluidEpic } from "./jetlift-input/fluid.epic";
import { jetliftJetPumpEpic } from "./jetlift-input/jetPump.epic";
import { jetliftGasCalculationEpic } from "./jetlift-output/gasCalcs.epic";
import { jetLiftBasicEpic } from "./jetlift-output/basicCal.epic";
import { jetLiftWellSurveyEpic } from "./jetlift-output/wellSurvey.epic";

export const jetliftRootEpic = combineEpics(
    jetliftCalculationEpic,
    jetLiftTubingEpic,
    jetLiftWellEpic,
    jetLiftFluidEpic,
    jetliftJetPumpEpic,
    jetliftGasCalculationEpic,
    jetLiftBasicEpic,
    jetLiftWellSurveyEpic
);